import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { TenantContextService } from './tenant-context.service';

interface GraphqlResponse<T> {
  data?: T;
  errors?: Array<{ message: string }>;
}

@Injectable({
  providedIn: 'root',
})
export class PublicHttpService {
  private readonly apiUrl = environment.api.httpUrl;

  constructor(private readonly tenantContext: TenantContextService) {}

  async query<T>(query: string, variables?: Record<string, unknown>): Promise<T> {
    return this.execute<T>(query, variables);
  }

  async mutate<T>(mutation: string, variables?: Record<string, unknown>): Promise<T> {
    return this.execute<T>(mutation, variables);
  }

  private async execute<T>(query: string, variables?: Record<string, unknown>): Promise<T> {
    const response = await fetch(this.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-tenant-id': this.tenantContext.getTenantIdOrFallback(),
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      throw new Error(`GraphQL request failed: ${response.status}`);
    }

    const body = (await response.json()) as GraphqlResponse<T>;
    if (body.errors && body.errors.length > 0) {
      throw new Error(body.errors.map((error) => error.message).join('; '));
    }

    if (!body.data) {
      throw new Error('GraphQL response missing data');
    }

    return body.data;
  }
}
